import { apiClient } from '@/shared/data/client';
import type { GridQueryInput } from '@/ui/composites/grid/gridUtils';
import type { ContactSubmissionDto, QueryResult } from '@flowqa/shared';

export type ContactSubmissionCreateInput = {
  name: string;
  email: string;
  subject: string;
  message: string;
  sourcePath: string;
  sourceContext: string;
};

type ContactSubmissionCreateResponse = {
  status: 'ok';
};

export const createContactSubmission = async (
  input: ContactSubmissionCreateInput,
): Promise<ContactSubmissionCreateResponse> => {
  return await apiClient.post<ContactSubmissionCreateResponse>('contact-submissions', input, {
    skipAuthRecovery: true,
  });
};

export const querySuperuserContactSubmissions = async (
  input: GridQueryInput,
): Promise<QueryResult<ContactSubmissionDto>> => {
  return await apiClient.post<QueryResult<ContactSubmissionDto>>(
    'superuser/contact-submissions/query',
    input,
  );
};

export const closeSuperuserContactSubmission = async (
  id: string,
): Promise<ContactSubmissionDto> => {
  return await apiClient.post<ContactSubmissionDto>(
    `superuser/contact-submissions/${id}/close`,
    undefined,
  );
};

export const reopenSuperuserContactSubmission = async (
  id: string,
): Promise<ContactSubmissionDto> => {
  return await apiClient.post<ContactSubmissionDto>(
    `superuser/contact-submissions/${id}/reopen`,
    undefined,
  );
};
